"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPlaceholder = exports.SearchDropdownIndicator = exports.Menu = exports.IndicatorSeparator = exports.DropdownIndicator = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var react_1 = __importDefault(require("react"));
var react_select_1 = require("react-select");
var DropdownIndicator = function (props) {
    return (null);
};
exports.DropdownIndicator = DropdownIndicator;
var IndicatorSeparator = function (props) {
    return (null);
};
exports.IndicatorSeparator = IndicatorSeparator;
var Menu = function (props) {
    if (props.options.length > 1) {
        return (react_1.default.createElement(react_select_1.components.Menu, __assign({}, props), props.children));
    }
    return (null);
};
exports.Menu = Menu;
var SearchDropdownIndicator = function (props) {
    return (react_1.default.createElement("p", { className: "control package-search-icon" },
        react_1.default.createElement("span", { className: "icon is-small is-right" },
            react_1.default.createElement("i", { className: "fas fa-search" }))));
};
exports.SearchDropdownIndicator = SearchDropdownIndicator;
var SearchPlaceholder = function (props) {
    return (react_1.default.createElement(react_select_1.components.Placeholder, __assign({}, props),
        react_1.default.createElement("span", { className: "icon is-small is-right" },
            react_1.default.createElement("i", { className: "fas fa-search" })),
        props.children));
};
exports.SearchPlaceholder = SearchPlaceholder;
